<template>
  <div class="c-my-music-expand-my-note">
    <ul class="my-note-list">
      <li class="my-note-list__item" v-for="d of myNoteList" :key="d.accountNoteUid">
        <div class="cover-delete-wrap">
          <div class="cover-name">
            <img class="cover-name__cover" :src="imageSource(d.cover)" />
            <p class="cover-name__name">{{ d.trackName }}{{ getSubInfo(d.editType, d.versionType) }}</p>
          </div>
          <img class="delete" src="@/assets/searchResults/icon_popup_note_delete.svg"
            @click="deleteNote(d.accountNoteContentUid)" />
        </div>
        <div class="note-time-edit">
          <div class="note-time">
            <p class="note-time__note-text">{{ d.content }}</p>
            <p class="note-time__time-text">{{ d.updatedAt }}</p>
          </div>
          <div class="edit">
            <span class="edit__text" @click="openEditNoteModal(d)">{{ $t('global.edit') }}</span>
          </div>
        </div>
      </li>
    </ul>

    <n-modal v-model:show="modelStatus" preset="dialog" :show-icon="false" :style="{ 'max-width': '800px' }">
      <model-base-layout
        :title="`${$t('myMusic.editNote')} - ${noteData.trackName}${getSubInfo(noteData.editType, noteData.versionType, false)}`">
        <edit-note :data="noteData" :noteData="noteData" @close="handleModelStatus" />
      </model-base-layout>
    </n-modal>
  </div>
</template>
<script>
import {
  defineComponent, watch, ref, computed,
} from 'vue';
import { NModal, useMessage } from 'naive-ui';
import dayjs from 'dayjs';
import { useI18n } from 'vue-i18n';
import { getAccountNoteContentAllAPI, removeAccountNoteAPI } from '@/api/myMusicNotes';
import useRequest from '@/hooks/useRequest';
import ModelBaseLayout from '@/components/Global/Popup/ModelBaseLayout.vue';
import imageSource from '@/utils/imageSource';
import EditNote from '@/components/Global/Popup/EditNote.vue';
import { useCacheStore } from '@/store/cache';
import getSubInfo from '@/utils/getSubInfo';

export default defineComponent({
  name: 'MyMusicExpandMyNote',
  components: {
    NModal,
    ModelBaseLayout,
    EditNote,
  },
  setup() {
    const { t } = useI18n();
    const message = useMessage();
    const cacheStore = useCacheStore();
    const { request: removeAccountNoteRequest, response: removeAccountNoteResponse } = useRequest(removeAccountNoteAPI);
    const { request, response, isLoading } = useRequest(getAccountNoteContentAllAPI);
    const myNoteList = ref([]);
    const modelStatus = ref(false);
    const noteData = ref('');
    const noteList = computed(() => cacheStore.myMusicExpandNoteList);

    const getAccountNoteList = () => {
      request();
    };
    getAccountNoteList();

    watch(response, () => {
      const [err, res] = response.value;

      if (err) {
        // message.error(err.message);
        return;
      }

      myNoteList.value = res.getAccountNoteContentAll.map((item) => ({
        cover: item.accountNote.cover,
        trackName: item.accountNote.title,
        content: item.content,
        updatedAt: dayjs(item.updatedAt).format('D MMM YYYY HH:mm'),
        accountNoteContentUid: item.accountNoteContentUid,
        versionType: item.accountNote.versionType,
        editType: item.accountNote.editType,
      }));
    });

    const handleModelStatus = (status = true) => {
      modelStatus.value = status;
      request();
    };

    const openEditNoteModal = (content) => {
      noteData.value = content;

      handleModelStatus();
    };

    const deleteNote = (id) => {
      removeAccountNoteRequest({
        in: id,
      });
    };

    watch(removeAccountNoteResponse, () => {
      const [err, res] = response.value;

      if (err) {
        message.error(err.toString());
        return;
      }

      if (res) {
        message.success(t('myMusic.removeNoteSucceed'));

        request();
      }
    });

    return {
      myNoteList,
      isLoading,
      imageSource,
      deleteNote,
      openEditNoteModal,
      modelStatus,
      noteData,
      handleModelStatus,
      noteList,
      getSubInfo,
    };
  },
});
</script>
<style lang="scss" scoped>
.my-note-list {
  &__item {
    @include padding(12px);
    background-color: $c-white;

    &+& {
      margin-top: 12px;
    }
  }
}

.cover-delete-wrap {
  @include flex(space-between);

}

.cover-name {
  @include flex();

  &__cover {
    width: 30px;
    height: 30px;
  }

  &__name {
    margin-left: 12px;
    @include font-style($c-black, 14, 600, 0.7px, 26px);
    @include word-ellipsis;
  }
}

.delete {
  cursor: pointer;
}

.note-time-edit {
  margin-top: 12px;
  @include flex(space-between, flex-end);
}

.note-time {
  &__note-text {
    @include font-style($c-assist4, 14, normal, 0.8px, 26px);
  }

  &__time-text {
    @include font-style($c-assist4, 12, normal, 0.6px, 18px);
  }
}

.edit {
  @include padding(0 10px);
  @include flex(center);
  display: inline-block;
  background-color: $c-assist15;
  height: 26px;
  border-radius: 13px;
  cursor: pointer;

  &__text {
    @include font-style($c-white, 14, normal, 0.7px, 26px);
  }
}
</style>
